/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SearchCategory } from './SearchCategory';
import {
    SearchCategoryFromJSON,
    SearchCategoryFromJSONTyped,
    SearchCategoryToJSON,
    SearchCategoryToJSONTyped,
} from './SearchCategory';
import type { SearchSortingRequestDto } from './SearchSortingRequestDto';
import {
    SearchSortingRequestDtoFromJSON,
    SearchSortingRequestDtoFromJSONTyped,
    SearchSortingRequestDtoToJSON,
    SearchSortingRequestDtoToJSONTyped,
} from './SearchSortingRequestDto';
import type { SearchRequestDto } from './SearchRequestDto';
import {
    SearchRequestDtoFromJSON,
    SearchRequestDtoFromJSONTyped,
    SearchRequestDtoToJSON,
    SearchRequestDtoToJSONTyped,
} from './SearchRequestDto';
import type { FilterRequestDto } from './FilterRequestDto';
import {
    FilterRequestDtoFromJSON,
    FilterRequestDtoFromJSONTyped,
    FilterRequestDtoToJSON,
    FilterRequestDtoToJSONTyped,
} from './FilterRequestDto';
import type { PagingRequestDto } from './PagingRequestDto';
import {
    PagingRequestDtoFromJSON,
    PagingRequestDtoFromJSONTyped,
    PagingRequestDtoToJSON,
    PagingRequestDtoToJSONTyped,
} from './PagingRequestDto';

/**
 * 
 * @export
 * @interface SearchPagedRequestDto
 */
export interface SearchPagedRequestDto {
    /**
     * 
     * @type {SearchRequestDto}
     * @memberof SearchPagedRequestDto
     */
    search?: SearchRequestDto;
    /**
     * 
     * @type {FilterRequestDto}
     * @memberof SearchPagedRequestDto
     */
    filters?: FilterRequestDto;
    /**
     * 
     * @type {SearchCategory}
     * @memberof SearchPagedRequestDto
     */
    category?: SearchCategory;
    /**
     * 
     * @type {PagingRequestDto}
     * @memberof SearchPagedRequestDto
     */
    paging?: PagingRequestDto;
    /**
     * 
     * @type {SearchSortingRequestDto}
     * @memberof SearchPagedRequestDto
     */
    sorting?: SearchSortingRequestDto;
}



/**
 * Check if a given object implements the SearchPagedRequestDto interface.
 */
export function instanceOfSearchPagedRequestDto(value: object): value is SearchPagedRequestDto {
    return true;
}

export function SearchPagedRequestDtoFromJSON(json: any): SearchPagedRequestDto {
    return SearchPagedRequestDtoFromJSONTyped(json, false);
}

export function SearchPagedRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchPagedRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'search': json['search'] == null ? undefined : SearchRequestDtoFromJSON(json['search']),
        'filters': json['filters'] == null ? undefined : FilterRequestDtoFromJSON(json['filters']),
        'category': json['category'] == null ? undefined : SearchCategoryFromJSON(json['category']),
        'paging': json['paging'] == null ? undefined : PagingRequestDtoFromJSON(json['paging']),
        'sorting': json['sorting'] == null ? undefined : SearchSortingRequestDtoFromJSON(json['sorting']),
    };
}

export function SearchPagedRequestDtoToJSON(json: any): SearchPagedRequestDto {
    return SearchPagedRequestDtoToJSONTyped(json, false);
}

export function SearchPagedRequestDtoToJSONTyped(value?: SearchPagedRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'search': SearchRequestDtoToJSON(value['search']),
        'filters': FilterRequestDtoToJSON(value['filters']),
        'category': SearchCategoryToJSON(value['category']),
        'paging': PagingRequestDtoToJSON(value['paging']),
        'sorting': SearchSortingRequestDtoToJSON(value['sorting']),
    };
}

